<template>
  <a-breadcrumb class="breadcrumb">
    <span slot="separator">
      <a-icon type="caret-right" />
    </span>
    <a-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.path">
      <template v-if="item.dynamicPath">
        <router-link :to="item.dynamicPath($route)" v-if="index < breadcrumbs.length - 1">
          <span>{{ item.title }}</span>
          <span v-if="item.isDisplayId && $route.params && $route.params.id"> - {{ $route.params.id }}</span>
        </router-link>
      </template>
      <template v-else>
        <router-link :to="item.isDisplayId && $route.params && $route.params.id ? item.path + '/' + $route.params.id : item.path" v-if="index < breadcrumbs.length - 1">
          <span>{{ item.title }}</span>
          <span v-if="item.isDisplayId && $route.params && $route.params.id"> - {{ $route.params.id }}</span>
        </router-link>
        <template v-if="index == breadcrumbs.length - 1">
          <span>{{ item.title }}</span>
          <span v-if="item.isDisplayId && $route.params && $route.params.id"> - {{ $route.params.id }}</span>
        </template>
      </template>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
  export default {
    name: 'Breadcrumb',
    mounted() {
      const breadcrumbInit = this.$route.meta.breadcrumb;
      this.$store.dispatch('setBreadcrumb', breadcrumbInit);
    },
    computed: {
      breadcrumbs() {
        return this.$store.state.breadcrumb.data;
      }
    },
    watch: {
      $route(to, from) {
        const breadcrumbInit = to.meta.breadcrumb;
        this.$store.dispatch('setBreadcrumb', breadcrumbInit);
      }
    }
  };
</script>

<style></style>
